import { Subscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';
import { AutocompleteMessenger, AutocompleteMessengerEvent } from './messenger';
import { StockSymbol } from '@benzinga/session';
import { AutocompleteRequest } from './request';
import { SafePromise } from '@benzinga/safe-await';
import { SymbolsResult } from './entities';

interface AutocompleteNewMessengerCreated {
  messenger: AutocompleteMessenger;
  type: 'autocomplete_new_messenger_create';
}

export type AutocompleteManagerEvent = AutocompleteNewMessengerCreated | AutocompleteMessengerEvent;

/**
 *  Responsible for creation of AutocompleteMessenger for each
 *  instanced Autocomplete component
 */
export class AutocompleteManager extends Subscribable<AutocompleteManagerEvent> {
  private session: Session;
  private request: AutocompleteRequest;

  constructor(session: Session) {
    super();
    this.session = session;
    this.request = new AutocompleteRequest(session);
  }

  public static getName = () => 'benzinga-autocomplete';

  public getMessenger = (): AutocompleteMessenger => {
    const messenger = new AutocompleteMessenger(this.session);
    this.dispatch({
      messenger,
      type: 'autocomplete_new_messenger_create',
    });
    return messenger;
  };

  public getAutocompleteListing = async (
    symbol: StockSymbol,
    options?: { limit?: number; types?: string },
  ): SafePromise<SymbolsResult> => {
    return await this.request.getAutoCompleteSymbols(symbol, options?.limit ?? 100, options?.types);
  };
}
